import { formatarDinheiro } from '@/pages/gerenciar/utils';
import type { PainelLoja } from '@/pages/fichas/types';

interface Props {
  painel: PainelLoja;
  rotuloPontos: string;
}

interface Tile {
  chave: string;
  rotulo: string;
  valor: string;
  icone: string;
  tom: 'primary' | 'success' | 'warning';
}

// Tiles do resumo de vendas: atualizados pelo sinal em tempo real.
export default function ResumoVendas({ painel, rotuloPontos }: Props) {
  const tiles: Tile[] = [
    {
      chave: 'vendido',
      rotulo: 'Vendido',
      valor: formatarDinheiro(painel.vendido_centavos),
      icone: 'ri-money-dollar-circle-line',
      tom: 'success',
    },
    {
      chave: 'fichas',
      rotulo: 'Fichas vendidas',
      valor: String(painel.fichas_vendidas),
      icone: 'ri-coupon-3-line',
      tom: 'primary',
    },
    {
      chave: 'barracas',
      rotulo: `${rotuloPontos} abertas`,
      valor: `${painel.pontos_abertos}/${painel.pontos_total}`,
      icone: 'ri-store-2-line',
      tom: 'primary',
    },
    {
      chave: 'esgotados',
      rotulo: 'Esgotados',
      valor: String(painel.produtos_esgotados),
      icone: 'ri-close-circle-line',
      tom: 'warning',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {tiles.map((t) => {
        const iconeTom =
          t.tom === 'primary'
            ? 'bg-primary-50 text-primary-600'
            : t.tom === 'success'
              ? 'bg-success-100 text-success-600'
              : 'bg-warning-100 text-warning-700';
        return (
          <div
            key={t.chave}
            className="min-w-0 overflow-hidden rounded-3xl bg-white p-4 shadow-[0_6px_18px_rgba(20,25,60,.06)]"
          >
            <span className={`flex h-9 w-9 items-center justify-center rounded-xl ${iconeTom}`}>
              <i className={`${t.icone} text-lg`} />
            </span>
            <span className="mt-3 block truncate text-[24px] font-extrabold leading-none tabular-nums text-foreground-950">
              {t.valor}
            </span>
            <span className="mt-1.5 block truncate text-[13px] text-foreground-500">{t.rotulo}</span>
          </div>
        );
      })}
    </div>
  );
}